import { render, staticRenderFns } from "./Sobity.vue?vue&type=template&id=cba0eb54&scoped=true&"
import script from "./Sobity.vue?vue&type=script&lang=js&"
export * from "./Sobity.vue?vue&type=script&lang=js&"
import style0 from "./Sobity.vue?vue&type=style&index=0&id=cba0eb54&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cba0eb54",
  null
  
)

export default component.exports